import { Main } from "./components/Main";
import { Loading } from "./components/tools";
import { useGlobalContext } from "./context";

import { ThemeProvider } from "./context/ThemeProvider";
import { Toaster } from "./components/ui";

function App() {
  const { loading } = useGlobalContext();

  if (loading) {
    return <Loading />;
  }

  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <div className="App">
        <Main />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
